import request from '@/api/request'
/**
 * 收藏/取消收藏
 */
export function collectApi (data) {
  return request({
    url: '/auth/collection/collect',
    method: 'post',
    data
  })
}

/**
 * 收藏列表
 */
export function collectListApi () {
  return request({
    url: '/auth/collection/list',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/my/collect.js